import cookieManager from '../../../../utils/cookieManager';
import axios from '@/enhancers/axios';
import BalanceSheetActions from '../../../../reducers/modules/report/balance-sheet/actions';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Navigate } from 'react-router-dom';

const MySwal = withReactContent(Swal)
const url=process.env.REST_URL +'report/balance-sheet'

export default class BalanceSheetMiddleware {

  static create(params){
    return (dispatch) => {
      dispatch(BalanceSheetActions.create());
    };
  }

  static update(params){
    return (dispatch) => {
      BalanceSheetMiddleware.showOne(dispatch, params);
      dispatch(BalanceSheetActions.update());
    };
  }
  static resetList(){
    return (dispatch) => {
        dispatch(BalanceSheetActions.resetList());
      };
  }
  static list(params){
      return (dispatch) => {
          dispatch(BalanceSheetActions.process());
          BalanceSheetMiddleware.showlist(dispatch, params);
        };
  }
  static showExcel(params){
    return (dispatch) => {
        dispatch(BalanceSheetActions.process());
        BalanceSheetMiddleware.beforeShowExcel(dispatch, params);
      };
}

  static beforeShowExcel(dispatch, params) {
 
  } 

  static listing(params){
    return (dispatch) => {
        dispatch(BalanceSheetActions.process());
        BalanceSheetMiddleware.showlisting(dispatch, params);
      };
}
  static reset(){
    return (dispatch) => {
        dispatch(BalanceSheetActions.reset());
      };
}
  static getOne(params){
    return (dispatch) => {
        dispatch(BalanceSheetActions.view());
        BalanceSheetMiddleware.showOne(dispatch, params);
      };
  }
  static getPrint(params) {
    return (dispatch) => {
      dispatch(BalanceSheetActions.beforePrint());
      BalanceSheetMiddleware.showPrint(dispatch, params);
    };
  }

  static beforeSaveNew(post,search){
    return (dispatch) => {
        dispatch(BalanceSheetActions.submit());
        BalanceSheetMiddleware.saveNew(dispatch, post,search);
      };
  }
  static beforeSaveUpdate(post,params){
    return (dispatch) => {
        dispatch(BalanceSheetActions.submit());
        BalanceSheetMiddleware.saveUpdate(dispatch, params, post);
      };
  }
  static beforeDelete(id,params){
    return (dispatch) => {
        dispatch(BalanceSheetActions.delete());
        BalanceSheetMiddleware.delete(dispatch,params,id);
      };
  }

  static getToken(){
      return cookieManager.getUserToken();
  }

  static getHelper(params=null){
    return (dispatch) => {
      BalanceSheetMiddleware.showHelper(dispatch,params);
      };
  }

  static async showPrint(dispatch, params) {
    console.log(Document.cookie);
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${BalanceSheetMiddleware.getToken()}`,
      },
      url: process.env.REST_URL +'report/balance-sheet/print',
      responseType: "json",
      data:params
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(BalanceSheetActions.print(response.data.result));
        }
      })
      .catch((error) => {
        BalanceSheetMiddleware.alertHendler(dispatch, error);
      });
  }
 
  static showHelper(dispatch,params){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${BalanceSheetMiddleware.getToken()}`
        },
        url:process.env.REST_URL+'helper/get-helper-work-sheet' ,
        responseType: 'json',
        params:params
      })
      .then((response) => {
        
        if (response && response.status === 200 && response.data) {
          dispatch(BalanceSheetActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        BalanceSheetMiddleware.alertHendler(dispatch,error)
      });
  }

  static showlist(dispatch, params){

      axios({
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${BalanceSheetMiddleware.getToken()}`
          },
          url: url,
          responseType: 'json',
          params:params
        })
        .then((response) => {
          
          if (response && response.status === 200 && response.data) {
            dispatch(BalanceSheetActions.list(response.data.result));
          }
        })
        .catch((error) => {
          BalanceSheetMiddleware.alertHendler(dispatch,error)
        });
  }

  static showlisting(dispatch, params){
    axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${BalanceSheetMiddleware.getToken()}`
        },
        url: url,
        responseType: 'json',
        params:params
      })
      .then((response) => {
        
        if (response && response.status === 200 && response.data) {
          dispatch(BalanceSheetActions.list(response.data.result));
        }
      })
      .catch((error) => {
        BalanceSheetMiddleware.alertHendler(dispatch,error)
      });
}

  static showOne(dispatch, params){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${BalanceSheetMiddleware.getToken()}`
        },
        url: url +'/'+params,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(BalanceSheetActions.view(response.data.result));
        }
      })
      .catch((error) => {
        BalanceSheetMiddleware.alertHendler(dispatch,error)
      });
  }

  static delete(dispatch, params,id){
    axios({
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${BalanceSheetMiddleware.getToken()}`
        },
        url: url +'/'+id,
        responseType: 'json'
      })
      .then((response) => {
       
        if (response && response.status === 200 && response.data) {
          MySwal.close()
          dispatch(BalanceSheetActions.process(),BalanceSheetMiddleware.showlist(dispatch, params));
          BalanceSheetMiddleware.alertHendler(dispatch,response,true,'Delete Data Successfully','success')
        }
      })
      .catch((error) => {
        BalanceSheetMiddleware.alertHendler(dispatch,error,true)
      });
  }

  static saveNew(dispatch, post,search){
    axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${BalanceSheetMiddleware.getToken()}`
        },
        url: url,
        data:post,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(BalanceSheetActions.process(),BalanceSheetMiddleware.showlist(dispatch,search));
          dispatch(BalanceSheetActions.success());
          BalanceSheetMiddleware.alertHendler(dispatch,response,true,'Create Data Successfully','success')
        }
      })
      .catch((error) => {
        BalanceSheetMiddleware.alertHendler(dispatch,error)
      });
  }

  static saveUpdate(dispatch, params, post){
    axios({
        method: 'PUT',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Bearer ${BalanceSheetMiddleware.getToken()}`
        },
        url: url+'/'+params,
        data:post,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          // dispatch(BalanceSheetActions.process(),BalanceSheetActions.showlist(dispatch,search));
          // dispatch(BalanceSheetActions.success());
          // BalanceSheetMiddleware.alertHendler(dispatch,response,true,'Update Data Successfully','success')
        }
      })
      .catch((error) => {
        BalanceSheetMiddleware.alertHendler(dispatch,error)
      });
  }

  static alertHendler(dispatch,result,isSwal=false,extraMessage='',type='error'){
    if(type=='error'){
      if (result.response) {
        const status=result.response.status
        switch(status){
          
          case 500:
            if(isSwal){
              const data=result.response.data
              MySwal.hideLoading()
              MySwal.update({
                title:'Delete Error',
                html:data.error,
                icon:'error',
                showConfirmButton:true,
              })
            }else{
              const data=result.response.data
              dispatch(BalanceSheetActions.error(data.error));
            }
          break;  
          case 403:
            console.log('Error 403');
          break;     
          case 404:
            console.log('Error 404');
          break;   
          case 401:
            const data=result.response.data
              MySwal.fire({
                title:'Login Invalid',
                html:data.error,
                icon:'error',
                showConfirmButton:true,
              }).then((result)=>{
                  if(result.isConfirmed){
                    <Navigate to="/login"></Navigate>
                  }
              })
          break;   
        }
      } else if (result.request) {
        MySwal.fire({
          title:'Internal Server Error',
          html:'Please info your Developer to fix this',
          icon:'error',
          showConfirmButton:true,
        })
        dispatch(BalanceSheetActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', result.message);
      }
    }else{
      MySwal.fire({
        title:'Success',
        html:extraMessage,
        icon:'success',
        showConfirmButton:true,
      })
    }
  }
}
